import * as Types from '__generated__/types';

import { gql } from '@apollo/client';
export type ErpPermissionFragment = { __typename?: 'ErpPermission', id: number, group: string, action: string, name: string, label?: string | null };

export const ErpPermissionFragmentDoc = gql`
    fragment erpPermission on ErpPermission {
  id
  group
  action
  name
  label
}
    `;